module.exports = __webpack_public_path__ + "media/images/redesign-images/home/home-exclusives-4-2ad4ad57571167efdab0753c1eacd334.jpg";